/**
 * A map of project names (operation.group) and corresponding base urls.
 */
export const baseUrls: Record<string, string | undefined> = {
  'circle-mint': process.env.CIRCLE_MINT_BASE_URL,
  w3s: process.env.API_BASE_URL,
  verite: process.env.VERITE_BASE_URL,
  stablecoins: process.env.STABLECOIN_BASE_URL,
}
